import React from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";

class ShareComponent extends React.Component {
  closeModel = (e) => {
    this.props.onClose && this.props.onClose(e);
  };

  render() {
    return (
      <>
        {this.props.show ? (
          <div className="share-dialog-box-component">
            <div className="dialog-box-wrapper">
              <div className="diaog-box">
                <div className="close-dialog">
                  <p className="dialog-box-heading">Share a Link</p>
                  <i
                    className="fa fa-times"
                    aria-hidden="true"
                    onClick={(e) => {
                      this.closeModel(e);
                    }}
                  ></i>
                </div>
                <form>
                  <div className="email-input">
                    <i className="fa fa-link grey-i" aria-hidden="true"></i>
                    <input
                      type="text"
                      id="shareEmailInput"
                      placeholder="Send a link to this topic via email"
                      required
                      value={window.location.href}
                      readOnly
                    />
                  </div>
                </form>
                <div className="copy-link">
                  <CopyToClipboard
                    text={window.location.href}
                    onCopy={() => document.querySelector('.copy-link-text').innerHTML='Link Copied'}
                  >
                    <p className="copy-link-text">Copy Link</p>
                  </CopyToClipboard>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </>
    );
  }
}

export default ShareComponent;